import { useContext, useMemo } from "react";
import { PartnerWithCTrees } from "@components";
import { Hero, Features, News, } from "./components";
import HeaderOffsetContext from "@/contexts/HeaderOffsetContext";

export default function ProductTemplate(props) {
    const { constants, product } = props;
    const headerOffsets = useContext(HeaderOffsetContext);
    const heroOffsets = useMemo(() => {
        if (!headerOffsets) {
            return {};
        }

        const { desktop, mobile } = headerOffsets;
        return {
            "--hero-nav-height-desktop": `${desktop.navHeight}px`,
            "--hero-nav-height-mobile": `${mobile.navHeight}px`,
        };
    }, [headerOffsets]);

    return (
        <div className="header-offset flex flex-col items-center">
            <div className="hero-offset w-full" style={heroOffsets}>
                <Hero props={constants.hero} />
            </div>
            <Features props={constants.features} />
            <PartnerWithCTrees />
            <News props={product} />
            {/* <FAQ props={constants.questionList} /> */}
        </div>
    );
}
